/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AuditProblemSummary
 */
export interface AuditProblemSummary {
  /**
   * Carrier-friendly name for the problem, e.g. "Liftgate at Delivery".
   * Never our internal note or evidence.
   *
   * @type {string}
   * @memberof AuditProblemSummary
   */
  label: string;
  /**
   *
   * @type {boolean}
   * @memberof AuditProblemSummary
   */
  resolved: boolean;
}

/**
 * Check if a given object implements the AuditProblemSummary interface.
 */
export function instanceOfAuditProblemSummary(
  value: object,
): value is AuditProblemSummary {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("resolved" in value) || value["resolved"] === undefined) return false;
  return true;
}

export function AuditProblemSummaryFromJSON(json: any): AuditProblemSummary {
  return AuditProblemSummaryFromJSONTyped(json, false);
}

export function AuditProblemSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuditProblemSummary {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    resolved: json["resolved"],
  };
}

export function AuditProblemSummaryToJSON(json: any): AuditProblemSummary {
  return AuditProblemSummaryToJSONTyped(json, false);
}

export function AuditProblemSummaryToJSONTyped(
  value?: AuditProblemSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    resolved: value["resolved"],
  };
}
